import React, { useEffect, useState } from "react";
import "./MyAccount.css";
import { useUserContext } from "../../../context/MemorialContext";
import { ProgressBar } from "react-loader-spinner";
import dummy from "../../../assets/dummy.jpg";
import Button from "../../components/button/Button";
import { toast } from "react-toastify";

function MyAccount() {
  const { user, signOut, fetchUser } = useUserContext();
  const [resetEmail, setResetEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const fileInputRef = React.useRef(null);
  const [resetLoading, setResetLoading] = useState(false);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  //para dirección
  const [shippingAddress, setShippingAddress] = useState("");

  const notifyError = (msg) =>
    toast.error(msg || "Something went wrong", {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const sendPasswordReset = async () => {
    if (!resetEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(resetEmail)) {
      notifyError("Please enter a valid email address");
      return;
    }
    setResetLoading(true);
    try {
      const res = await fetch(`${backendUrl}/api/send-password-reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: resetEmail }),
      });
      if (res.ok) {
        toast.success("Password reset email sent. Check your inbox.");
      } else {
        const data = await res.json().catch(() => ({}));
        notifyError(data.message);
      }
    } catch {
      notifyError("No se pudo enviar el correo. Revisa que el backend esté en marcha.");
    } finally {
      setResetLoading(false);
    }
  };
  const { meta } = user;
  const [isImgLoading, setIsImageLoading] = React.useState(false);
  const handleDisplayPictureChange = async (event, functionality) => {
    const formData = new FormData();
    if (functionality === "imageUpload") {
      const selectedFile = event.target.files[0];
      formData.append("displayPicture", selectedFile);
      setIsImageLoading(true);
    } else {
      formData.append("name", `${firstName} ${lastName}`);
      formData.append("email", email);
      formData.append("shippingAddress", shippingAddress);
    }

    try {
      // Make a request to the backend endpoint to upload the display picture
      const response = await fetch(`${backendUrl}/api/users/${meta._id}`, {
        method: "PUT",
        body: formData,
      });

      if (response.ok) {
        toast("User Details Updated Sucessfully");
        setIsImageLoading(false);
        fetchUser();
      } else {
        // Error uploading display picture, handle the error
        console.error("Error uploading display picture:", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading display picture:", error);
    }
  };
  const handleAvatarClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    const name = meta?.name?.split(" ") || [];
    const firstName = name[0];
    const lastName = name[1];
    setFirstName(firstName);
    setLastName(lastName);
    setEmail(meta?.email);
    setShippingAddress(meta?.shippingAddress || "");
  // Seed the form once from the loaded profile; do not overwrite edits if meta identity changes later.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="myAccountPage">
      <h2>My Account</h2>

      <div className="myAccountCard">
        <h2>Personal Information</h2>
        <div className="profile-picture-wrap">
          <div
            className="profile-picture-account"
            onClick={handleAvatarClick}
            role="button"
            tabIndex={0}
            aria-label="Change photo"
            title="Change photo"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleAvatarClick();
              }
            }}
          >
            {isImgLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ProgressBar
                  height="80"
                  width="80"
                  ariaLabel="progress-bar-loading"
                  wrapperStyle={{}}
                  wrapperClass="progress-bar-wrapper"
                  borderColor="#757575"
                  barColor="#757575"
                />
              </div>
            ) : (
              <>
                <img src={meta?.displayPicture || dummy} alt="Profile" />
                <div className="profile-picture-overlay" aria-hidden="true">
                  <span>Change photo</span>
                </div>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleDisplayPictureChange(e, "imageUpload")}
                  style={{ display: "none" }}
                />
              </>
            )}
          </div>
          <p className="profile-picture-hint">Click photo to change</p>
        </div>
        <div className="detailsSection">
          <div className="firstLine">
            <div className="singleInput">
              <p>First Name</p>
              <input
                value={firstName}
                type="text"
                placeholder="Joann"
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="singleInput">
              <p>Last Name</p>
              <input
                value={lastName}
                type="text"
                placeholder="Finn"
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <div className="secondLine">
            <p>Email</p>
            <input
              value={email}
              type="text"
              placeholder="joann@mail.com"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="secondLine">
            <p style={{ margin: "auto", marginBottom: "10px"}}>Shipping Address</p>
            <input
              value={shippingAddress}
              type="text"
              placeholder="Enter your physical address"
              onChange={(e) => setShippingAddress(e.target.value)}
            />
          </div>
          <div className="thirdLine">
            <h2>Change Password </h2>
            <div className="flex-card">
              <div className="SInputs">
                <div className="singleInput">
                  <p>Email:</p>
                  <input
                    placeholder="Enter your email"
                    value={resetEmail}
                    type="text"
                    onChange={(e) => setResetEmail(e.target.value)}
                  />
                </div>

                <div className="singleInput">
                  <Button
                    isLoading={resetLoading}
                    onClick={sendPasswordReset}
                    text="Reset Password"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="footerSection">
            <button onClick={(e) => handleDisplayPictureChange(e)}>Save</button>
            <button
              onClick={async () => {
                const success = await signOut();
                if (success) {
                  sessionStorage.removeItem("user");
                  sessionStorage.removeItem("formData");
                  window.location.href = "/login";
                }
              }}
            >
              Log out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyAccount;
